<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  title: string
  subtitle?: string
  meta?: string
  tone?: 'emerald' | 'cyan' | 'amber' | 'purple' | 'red' | 'blue'
}>(), {
  subtitle: '',
  meta: '',
  tone: 'cyan',
})

const dot = computed(() => ({
  emerald: 'bg-emerald-400',
  cyan: 'bg-cyan-400',
  amber: 'bg-amber-400',
  purple: 'bg-purple-400',
  red: 'bg-red-400',
  blue: 'bg-blue-400',
}[props.tone]))
</script>

<template>
  <div class="flex items-center gap-3 rounded-xl border border-slate-700/40 bg-slate-900/30 px-3 py-3">
    <span class="h-2.5 w-2.5 shrink-0 rounded-full" :class="dot"></span>

    <div class="min-w-0 flex-1">
      <p class="truncate text-sm font-semibold text-slate-100">{{ title }}</p>
      <p v-if="subtitle" class="mt-0.5 truncate text-[11px] text-slate-500">{{ subtitle }}</p>
    </div>

    <span v-if="meta" class="shrink-0 text-[10px] font-semibold text-slate-400">{{ meta }}</span>
  </div>
</template>
